import React from "react";
import { useEffect,useRef } from "react";
//import { useEffect,useRef } from "react";
import api from "../../utils/api";
import { useState } from "react";
import isEmpty from "lodash/isEmpty";
import { getServiceTypesMaster } from "../../utils/localStorage";
import find from "lodash/find";

import { toast } from "react-toastify";
import { getUser } from "../../utils/localStorage";
import { useHistory } from "react-router-dom";
import DateRange from "../../components/ServiceRequests/Facilitator/DateRange";
import useDebouncedEffect from "../../hoc/useDebouncedEffect";
import { useTable } from "react-table";
import { set, result, filter } from "lodash";
import CustomerFilter from "../../components/ServiceRequests/Facilitator/CustomerFilter";
import SelectDropdownFilter from "../../components/ServiceRequests/Facilitator/SelectDropdownFilter";
import ContainerActions from "../../components/ServiceRequests/Facilitator/ContainerActions";
import FacilitatorGridTable from "../../components/ServiceRequests/Facilitator/FacilitatorGridTable";
import CentralizedNotesModal from "../../components/ServiceRequests/Handholder/CentralizedNotesModal";
import UserFeedbackModal from "../../components/ServiceRequests/Handholder/UserFeedbackModal";
import ServiceStatusModal from "../../components/ServiceRequests/Facilitator/ServiceStatusModal";
//import UserServiceFeedbackModal from "../../components/ServiceRequests/Handholder/UserServiceFeedbackModal";
//import UserFacilitatorFeedbackModal from "../../components/ServiceRequests/Handholder/UserFacilitatorFeedbackModal";
import Spinner from "../../common/Spinner/Spinner";
import moment from "moment";
import CustomerFeedbackContainer from "../EServicePartnerServiceRequests/CustomerFeedbackContainer";
import FacilitatorActionsFilterSection from "../../components/ServiceRequests/Facilitator/FacilitatorActionsFilterSection";

export default function FacilitatorActionsContainer(props) {
	//const history = useHistory();

	const [isLoading, setIsLoading] = useState(false);
	//const [tableInstance, setTableInstance] = useState(null);

	const [facilitatorActionsList, setFacilitatorActionsList] = useState([]);
	const [selectedFacilitatorAction,setSelectedFacilitatorAction,] = useState();
	//const [pages, setPages] = useState(0);
	//const PAGE_SIZE = 10;
	const onSelectFacilitatorAction = (e) => {
		setSelectedFacilitatorAction(e);
	};




	const [pages, setPages] = useState(0);
	const [pageSize, setPageSize] = useState(10);
	const [currentPage, setcurrentPage] = useState(0);
	const [tableInstance, setTableInstance] = useState(null);
	const history = useHistory();
	const [count, setCount ] = useState(0);
	const [searchTerm, setSearchTerm] = useState();
	const [pageSizeOptions,setpageSizeOptions] = useState([
        {
            value: "10",
            label: "10 Rows",
        },
        {
            value: "20",
            label: "20 Rows",
        },
        {
            value: "30",
            label: "30 Rows",
        },
        {
            value: "50",
            label: "50 Rows",
        },
        {
            value: "75",
            label: "75 Rows",
        },
        {
            value: "100",
            label: "100 Rows",
        },
         
    ]);
    const [selectedPageSizeOption, setSelectedPageSizeOption] = useState({
        value: "10",
        label: "10",
    });

	useEffect(() => {
        getFacilitatorActions(tableInstance, true);
        setSelectedFacilitatorAction("");        
	}, [selectedPageSizeOption]);




	// const getFacilitatorActions = async (instance,flag = false) => {
	// 	if (!instance) return;
	// 	if (!tableInstance) setTableInstance(instance);
	// 	if (!getUser()) {
	// 		history.push("/login");
	// 	}

	// 	const { page } = instance.state ?? { page: 0 };
    //         let icurrentPage=page;
    //         if (!flag &&isNaN(icurrentPage)) return;
    //         const pageSize =selectedPageSizeOption.value;

    //         if(flag || isNaN(icurrentPage))
    //         {
    //             icurrentPage=0;
    //         }
			
			 

	// 	//let page = 0;
	// 	let sortParams = null;
	// 	if (instance.state.sorted.length > 0) {
	// 		const { id, desc } = instance.state.sorted[0];
	// 		sortParams = { column: id, desc };
	// 	}

	// 	let toDateAdjusted = new Date(toDate);
	// 	if (toDate) {
	// 		toDateAdjusted = new Date(
	// 			toDateAdjusted.setTime(
	// 				toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
	// 			)
	// 		);
	// 	}
	// 	//let filterParameters = { page:icurrentPage+1, ...sortParams };

	// 	let filterParameters = {
	// 		page:icurrentPage+1,
	// 		page_size:pageSize,
	// 		pagination:true,
	// 		...sortParams,
	// 	};

	// 	if(currentPage!=icurrentPage)
	// 	{
	// 		setSelectedFacilitatorAction([]);
	// 	}

	// 	if (showIncompleteActions)
	// 	filterParameters.completed = !showIncompleteActions;	

	// 	if (dateFilter && fromDate && toDate) {
	// 		filterParameters.date_field = dateFilter.value;
	// 		if (fromDate) {
	// 			filterParameters.date_range_from = fromDate;
	// 		}
	// 		if (toDate) {
	// 			filterParameters.date_range_to = toDate;
	// 		}
	// 	} 

	// 	SearchByDropdownList.map((x) => {
	// 		if (x.checked && searchTerm)
	// 		{
	// 			if(x.code==="CustomerName")
	// 			{
	// 				filterParameters.filter_value= searchTerm ;
	// 				filterParameters.filter_by="name"
	// 			}
	// 			else if(x.code==="ServiceInstanceID")
	// 			{
	// 				filterParameters.filter_value=searchTerm 
	// 				filterParameters.filter_by="service_id";
	// 			}
	// 			else if(x.code==="PackageProgramInstanceID")
	// 			{
	// 				filterParameters.filter_value=searchTerm;
	// 				filterParameters.filter_by="package_id"
	// 			}
	// 			else if(x.code==="CustomerEmailID")
	// 			{
	// 				filterParameters.filter_value=searchTerm;
	// 				filterParameters.filter_by="email_id"
	// 			}
	// 			else if(x.code==="PhoneNumber")
	// 			{
	// 				filterParameters.filter_value=searchTerm ;
	// 				filterParameters.filter_by="phone_number"
	// 			}
	// 		}
	// 	});

	// 	// SearchByDropdownList.map((x) => {
	// 	// 	if (x.checked && customerFilterValue)
	// 	// 	{
	// 	// 		if(x.code==="CustomerName")
	// 	// 		{
	// 	// 			filterParameters["filter_by"] = "name";
					
	// 	// 		}
	// 	// 		else if(x.code==="ServiceInstanceID")
	// 	// 		{
	// 	// 			filterParameters["filter_by"] = "nResourceInstanceID" ;
	// 	// 		}
	// 	// 		else if(x.code==="PackageProgramInstanceID")
	// 	// 		{
					 
	// 	// 			filterParameters["filter_by"]="nPackageInstanceId";
	// 	// 		}
	// 	// 		else if(x.code==="CustomerEmailID")
	// 	// 		{
	// 	// 			filterParameters["filter_by"]="email_id";
	// 	// 		}
	// 	// 		else if(x.code==="PhoneNumber")
	// 	// 		{
					
	// 	// 			filterParameters["filter_by"]="C_Phone";
	// 	// 		}
	// 	// 		filterParameters["filter_value"] = customerFilterValue;
	// 	// 	}
	// 	// });

	// 	let customerSearchFilter = {};
	// 	setIsLoading(true);	
	// 	await api.getFacilitatorServiceActions(filterParameters)
	// 		.then(({ data }) => {
	// 			count = data.count;
	// 			setcurrentPage(icurrentPage);
	// 			const totalPages = (count - 1) / pageSize + 1;
	// 			setCount(count);
	// 			setPages(Math.floor(totalPages));
	// 			setPageSize(pageSize);
	// 			let sortedArray = []
	// 			if (sortParams === null || sortParams["column"] === "dtFollowupOn") {
	// 				if (sortParams === null || sortParams["desc"] === true) {
	// 					sortedArray = data.results.sort((a, b) => moment(moment.utc(a["dtFollowupOn"]).toDate()).format("YYYYMMDD") - moment(moment.utc(b["dtFollowupOn"]).toDate()).format("YYYYMMDD")).reverse()
	// 				}
	// 				else if (sortParams["desc"] === false) {
	// 					sortedArray = data.results.sort((a, b) => moment(moment.utc(a["dtFollowupOn"]).toDate()).format("YYYYMMDD") - moment(moment.utc(b["dtFollowupOn"]).toDate()).format("YYYYMMDD"))
	// 				}
	// 			}
	// 			else {
	// 				sortedArray = data.results.sort((a, b) => moment(moment.utc(a["dtFollowupOn"]).toDate()).format("YYYYMMDD") - moment(moment.utc(b["dtFollowupOn"]).toDate()).format("YYYYMMDD")).reverse()
	// 			}
	// 			setFacilitatorActionsList(sortedArray);

	// 		});
	// 	setIsLoading(false);
	// };





	const getFacilitatorActions = async (instance, flag = false) => {
		if (!instance) return;
		if (!tableInstance) setTableInstance(instance);
		if (!getUser()) {
			history.push("/login");
		}
		try {

            const { page } = instance.state ?? { page: 0 };
            let icurrentPage=page;
            if (!flag &&isNaN(icurrentPage)) return;
            const pageSize =selectedPageSizeOption.value;

            if(flag || isNaN(icurrentPage))
            {
                icurrentPage=0;
            }

			let sortParams = null;
			if (instance.state.sorted.length > 0) {
				const { id, desc } = instance.state.sorted[0];
				sortParams = { column: id, desc };
			}

            let filterParameters = {
                page:icurrentPage+1,
                page_size:pageSize,
				pagination:true,
				...sortParams,
            };

            if(currentPage!=icurrentPage)
            {
                setSelectedFacilitatorAction([]);
            }

			if (showIncompleteActions)
			filterParameters.completed = !showIncompleteActions;	
	
			if (dateFilter && fromDate && toDate) {
				filterParameters.date_field = dateFilter.value;
				if (fromDate) {
					filterParameters.date_range_from = fromDate;
				}
				if (toDate) {
					filterParameters.date_range_to = toDate;
				}
			} 
	
			SearchByDropdownList.map((x) => {
				if (x.checked && searchTerm)
				{
					if(x.code==="CustomerName")
					{
						filterParameters.filter_value= searchTerm ;
						filterParameters.filter_by="name"
					}
					else if(x.code==="ServiceInstanceID")
					{
						filterParameters.filter_value=searchTerm 
						filterParameters.filter_by="service_id";
					}
					else if(x.code==="PackageProgramInstanceID")
					{
						filterParameters.filter_value=searchTerm;
						filterParameters.filter_by="package_id"
					}
					else if(x.code==="CustomerEmailID")
					{
						filterParameters.filter_value=searchTerm;
						filterParameters.filter_by="email_id"
					}
					else if(x.code==="PhoneNumber")
					{
						filterParameters.filter_value=searchTerm ;
						filterParameters.filter_by="phone_number"
					}
				}
			});

			
			setIsLoading(true);

			 api.getFacilitatorServiceActions(filterParameters).then(({data}) => {
                setIsLoading(false);
                if(data)
                {
                    let { results, count } = data;
                    setcurrentPage(icurrentPage);
                    const totalPages = (count - 1) / pageSize + 1;                    
                    setCount(count);
                    setPages(Math.floor(totalPages));
                    setPageSize(pageSize);
					 
					
					//let sortedArray = [];
					//sortedArray = data.results.sort((a, b) => moment(moment.utc(a["dtFollowupOn"]).toDate()).format("YYYYMMDD") - moment(moment.utc(b["dtFollowupOn"]).toDate()).format("YYYYMMDD")).reverse()
					// if (sortParams === null || sortParams["column"] === "dtFollowupOn") 
					// {
					// 	if (sortParams === null || sortParams["desc"] === true) 
					// 	{
					// 		sortedArray = this.data.results.sort((a, b) => moment(moment.utc(a["dtFollowupOn"]).toDate()).format("YYYYMMDD") - moment(moment.utc(b["dtFollowupOn"]).toDate()).format("YYYYMMDD")).reverse()
					// 	}
					// 	else if (sortParams["desc"] === false) 
					// 	{
					// 		sortedArray = this.data.results.sort((a, b) => moment(moment.utc(a["dtFollowupOn"]).toDate()).format("YYYYMMDD") - moment(moment.utc(b["dtFollowupOn"]).toDate()).format("YYYYMMDD"))
					// 	}
					// }
					// else 
					// {
					// 	sortedArray = this.data.results.sort((a, b) => moment(moment.utc(a["dtFollowupOn"]).toDate()).format("YYYYMMDD") - moment(moment.utc(b["dtFollowupOn"]).toDate()).format("YYYYMMDD")).reverse()
					// }
					setFacilitatorActionsList(results);
					
					//setSelectedFacilitatorAction(sortedArray);
                }
                else
                {
                    toast("", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
            }).catch((error) =>
            {
				console.log("jhjhhhhhhhhhhhhhhhhh")
				console.log(error)
				console.log("Balaji")
                setIsLoading(false);
                if(error.response.data.detail)
                {
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
                else if(error.response.data.message)
                {
                    toast(String(error.response.data.message), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
                else{
                    toast("Internal server error", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }                
            });
			
		}
        catch (error) 
        {
			console.error(error);
		}
	};





	/**
	 * Date range consts and call backs
	 *
	 */

	const [fromDate, setFromDate] = useState();
	const [toDate, setToDate] = useState();
	const [dateRangeOption, setDateRangeOptions] = useState([
		{
			value: "dtFollowupOn",
			label: "Followup On",
		},
		{
			value: "dtCreated",
			label: "Creation Date",
		},
		{
			value: "dtUpdated",
			label: "Updation Date",
		},
	]);
	const onDateRangeChange = (dateLable, dateValue) => {
		if (dateLable === "fromDate") {
			setFromDate(dateValue);
		}
		if (dateLable === "toDate") {
			setToDate(dateValue);
		}
	};
	const [dateFilter, setDateFilter] = useState({
		value: "dtFollowupOn",
		label: "Followup On",
	});
	const onDateFilterChange = (e) => {
		setDateFilter(e);
	};

	const onStatusOptionChange = (e) => {
		setSelectedOptions(e);
	};
	/**
	 *
	 */

	/**
	 * Customer filter

	 */

	const onSearchClicked = () => {
		getFacilitatorActions(tableInstance);
	};
	const [customerFilterOptions, setCustomerFilterOptions] = useState([
		{
			value: "name",
			label: "Customer Name",
		},
		{
			value: "email_id",
			label: "Customer Email",
		},
	]);
	const [customerFilter, setCustomerFilter] = useState();

	const onCustomerFilterChange = (e) => {
		setCustomerFilter(e);
	};
	const [customerFilterValue, setCustomerFilterValue] = useState();
	const onCustomerFilterValueChange = (e) => {
		setCustomerFilterValue(e.target.value);
	};

	/** */
	/**Handled checkbox */
	const [showIncompleteActions, setShowIncompleteActions] = useState(true);
	const toggleShowIncompleteActions = (_) => {
		setShowIncompleteActions(!showIncompleteActions);
	};





	/*Need to talk to SP*/
	const [needToTalkToSPOptions,setneedToTalkToSPOptions] = useState([
		{
			value: true,
			label: "Yes",
		},
		{
			value: false,
			label: "No",
		},
		]);
		const [
			selectedNeedToTalkToSPOption,
			setSelectedNeedToTalkToSPOption,
		] = useState({
			value: false,
			label: "No",
		});
	/*End*/
	/*Need to talk to sp callback */
	const onUpdateNeedToTalkToSPFlag = async () => {		
		let bNeedToTalkToSP=selectedNeedToTalkToSPOption.value;	
		const { nResourceInstanceId } = selectedFacilitatorAction;
		api.updateNeedtoTalkToSPFlagSPM(nResourceInstanceId,{bNeedToTalkToSP})
		.then((response) => {
			if (response.status == 202)
			{
				setSelectedFacilitatorAction({...selectedFacilitatorAction,bNeedToTalkToSP:bNeedToTalkToSP})
				if(response.data.message)
				{
					toast(response.data.message, {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
				}
				else
				{
					toast("Service updated successfully.", {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
				}
			}
			else
			{
				if(response.data.message)
				{
					toast(response.data.message, {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				}
				else
				{
					toast("Internal server error.", {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				}
			}
			// toggleNotesModal();
			// getFacilitatorActions(tableInstance);				
		})
		.catch((error) => {
			toast(String(error.response.data.message), {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		});	
	};
	/*end*/





	/** */

	//Notes Model New/
	/**
	 * Notes data
	 */
	
	//  const [showNotesModal, setNotesModalVisibility] = useState(false);
	//  const [notesDetails, setNotesDetails] = useState({});
	//  const [notesHistory, setNotesHistory] = useState([]);
	//  const [currentNote, setCurrentNote] = useState({});
	//  const [auditTrail, setAuditTrail] = useState({});
 
	//  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
 
	//  /**
 
	//  /**
	//   * Notes Modal Callbacks
	//   * 
	//   * 
	//   */
 
	//   const changeSelectedNotesDetails = (direction) => {
	// 	if (notesHistory.length === 0) return;

	// 	//sFollowupAction dtFollowupOn sNotes
	// 	let currentNoteIndex;
	// 	if (isEmpty(currentNote) == true && direction === "next") {
	// 		setNotesDetails({
	// 			sFollowupAction: "",
	// 			dtFollowupOn: "",
	// 			sNotes: "",
	// 			bHandled: false,
	// 			currentNoteIndex: -1,
	// 		});
	// 		return;
	// 	}
	// 	if (isEmpty(currentNote) == true && direction === "previous") {
	// 		currentNoteIndex = notesHistory.length - 1;
	// 		setCurrentNote(notesHistory[currentNoteIndex]);
	// 		setNotesDetails({});
	// 		setNotesDetails({
	// 			currentNoteIndex: currentNoteIndex,
	// 			sFollowupAction:
	// 				notesHistory[currentNoteIndex]["sFollowupAction"],
	// 			dtFollowupOn: notesHistory[currentNoteIndex]["dtFollowupOn"],
	// 			bHandled: notesHistory[currentNoteIndex]["bHandled"],
	// 			sNotes: notesHistory[currentNoteIndex]["sNotes"],
	// 		});
	// 		return;
	// 	}
	// 	notesHistory.map((e, i) => {
	// 		if (currentNote["id"] === e["id"]) {
	// 			currentNoteIndex = i;
	// 		}
	// 	});

	// 	if (direction === "previous" && currentNoteIndex > 0) {
	// 		currentNoteIndex -= 1;
	// 		setCurrentNote(notesHistory[currentNoteIndex]);
	// 		setNotesDetails({});
	// 		setNotesDetails({
	// 			currentNoteIndex: currentNoteIndex,
	// 			sFollowupAction:
	// 				notesHistory[currentNoteIndex]["sFollowupAction"],
	// 			dtFollowupOn: notesHistory[currentNoteIndex]["dtFollowupOn"],
	// 			sNotes: notesHistory[currentNoteIndex]["sNotes"],
	// 			bHandled: notesHistory[currentNoteIndex]["bHandled"],
	// 		});
	// 		return;
	// 	}
	// 	if (
	// 		direction === "next" &&
	// 		currentNoteIndex < notesHistory.length - 1
	// 	) {
	// 		currentNoteIndex += 1;
	// 		setCurrentNote(notesHistory[currentNoteIndex]);
	// 		setNotesDetails({});
	// 		setNotesDetails({
	// 			currentNoteIndex: currentNoteIndex,
	// 			sFollowupAction:
	// 				notesHistory[currentNoteIndex]["sFollowupAction"],
	// 			dtFollowupOn: notesHistory[currentNoteIndex]["dtFollowupOn"],
	// 			sNotes: notesHistory[currentNoteIndex]["sNotes"],
	// 			bHandled: notesHistory[currentNoteIndex]["bHandled"],
	// 		});
	// 		return;
	// 	}

	// 	if (
	// 		direction === "next" &&
	// 		currentNoteIndex === notesHistory.length - 1
	// 	) {
	// 		setCurrentNote({});
	// 		setNotesDetails({
	// 			sFollowupAction: "",
	// 			dtFollowupOn: "",
	// 			sNotes: "",
	// 			bHandled: false,
	// 			currentNoteIndex: -1,
	// 		});
	// 		return;
	// 	}
	// };

	// const toggleConfirmationModalNotes = () => {
	// 	setShowConfirmationModal(!showConfirmationModal);
	// };

	// const confirmChangeNotes = () => {
	// 	setSelectedFacilitatorAction("");
	// 	setNotesDetails({});
	// 	setNotesModalVisibility(!showNotesModal);
	// 	toggleConfirmationModalNotes();
	// 	setCurrentNote({});

	// };

 
	// const toggleNotesModal = async (e) => {

	// 	if (selectedFacilitatorAction) {
	// 		if (
	// 			notesDetails["currentNoteIndex"] !== -1 &&
	// 			(notesDetails["dtFollowupOn"] !== currentNote["dtFollowupOn"] ||
	// 				notesDetails["sNotes"] !== currentNote["sNotes"] ||
	// 				notesDetails["sFollowupAction"] !==
	// 					currentNote["sFollowupAction"] ||
	// 				notesDetails["bHandled"] !== currentNote["bHandled"])
	// 		) {
	// 			if(showNotesModal === true && (notesDetails["dtFollowupOn"] !== "" || notesDetails["sNotes"] !== "" || notesDetails["sFollowupAction"] !== "" || notesDetails["bHandled"] !== false)){
	// 				toggleConfirmationModalNotes()
	// 			}
	// 			else{
	// 				setNotesModalVisibility(!showNotesModal);
	// 			}
	// 			return;
	// 		} else {
	// 			setSelectedFacilitatorAction("");
	// 			setNotesDetails({});
	// 			setCurrentNote({});
	// 			setNotesHistory({});
	// 			setNotesModalVisibility(!showNotesModal);
	// 		}
	// 	} else {
	// 		let data = await api
	// 			.getNotesHistory({
	// 				nResourceInstanceId: e["nResourceInstanceId"],
	// 			})
	// 			.then((f) => {
	// 				setNotesHistory(f.data);
	// 			});


	// 			//Facilitator

	// 			// let data1 = await api
	// 			// .getAuditTrailNotesSPM({
	// 			// 	nResourceInstanceId: e["nResourceInstanceId"],
	// 			// })
	// 			// .then((f1) => {
	// 			// 	setAuditTrail(f1);
	// 			// });

	// 			//End
				
	// 			let payload={nResourceInstanceId:e["nResourceInstanceId"]};
	// 			api.getESPNotesLogByServiceId(payload).then(({ data }) => {
	// 				setAuditTrail(data);
	// 			});

	// 			if(e.bNeedToTalkToSP)
	// 			{
	// 				setSelectedNeedToTalkToSPOption({
	// 					value: true,
	// 					label: "Yes",
	// 				})
	// 			}
	// 			else
	// 			{
	// 				setSelectedNeedToTalkToSPOption({
	// 					value: false,
	// 					label: "No",
	// 				})
	// 			}
	// 		setSelectedFacilitatorAction(e);
	// 		setNotesModalVisibility(!showNotesModal);
	// 	}
	// };

	// const onNotesChange = (name, value) => {
	// 	const updated = {
	// 		...notesDetails,
	// 		[name]: value,
	// 	};
	// 	setNotesDetails(updated);
	// };

	// const onSaveNotesDetails = async () => {
	// 	if (
	// 		notesDetails["sNotes"] === "" ||
	// 		notesDetails["sNotes"] === undefined ||
	// 		notesDetails["sNotes"] === null
	// 	) {
	// 		toast("Notes field is mandetory", {
	// 			autoClose: 5000,
	// 			type: toast.TYPE.ERROR,
	// 		});
	// 		return;
	// 	}
	// 	if (
	// 		!(notesDetails["dtFollowupOn"] && notesDetails["sFollowupAction"])
	// 	) {
	// 		if (
	// 			(notesDetails["sFollowupAction"] === "" ||
	// 				notesDetails["sFollowupAction"] === null ||
	// 				notesDetails["sFollowupAction"] === undefined) &&
	// 			(notesDetails["dtFollowupOn"] === "" ||
	// 				notesDetails["dtFollowupOn"] === undefined ||
	// 				notesDetails["dtFollowupOn"] === null)
	// 		) {
	// 		} else if (
	// 			notesDetails["dtFollowupOn"] === "" ||
	// 			notesDetails["dtFollowupOn"] === undefined ||
	// 			notesDetails["dtFollowupOn"] === null
	// 		) {
	// 			toast("Followup Date is missing", {
	// 				autoClose: 5000,
	// 				type: toast.TYPE.ERROR,
	// 			});
	// 			return;
	// 		} else if (
	// 			notesDetails["sFollowupAction"] === "" ||
	// 			notesDetails["sFollowupAction"] === undefined ||
	// 			notesDetails["sFollowupAction"] === null
	// 		) {
	// 			toast("Followup Action is missing", {
	// 				autoClose: 5000,
	// 				type: toast.TYPE.ERROR,
	// 			});
	// 			return;
	// 		} else {
	// 		}
	// 	}

	// 	try {

	// 		let bNeedToTalkToSPnew=selectedNeedToTalkToSPOption.value;	
	// 		const { bNeedToTalkToSP } = selectedFacilitatorAction;
	// 		if(bNeedToTalkToSPnew!=bNeedToTalkToSP)
	// 		{
	// 			onUpdateNeedToTalkToSPFlag();
	// 		}

	// 		if (isEmpty(currentNote)) {
	// 			let data = await api
	// 				.saveNotes({
	// 					...notesDetails,
	// 					nResourceInstanceId:
	// 					selectedFacilitatorAction["nResourceInstanceId"],
	// 				})
	// 				.then(() => {
	// 					setSelectedFacilitatorAction("");
	// 					setNotesDetails({});
	// 					setCurrentNote({});
	// 					setNotesHistory({});
	// 					setNotesModalVisibility(false);
	// 				});



	// 			//Facilitator

	// 			//  let data1 = await api
	// 			// 	.getAuditTrailNotesSPM({
	// 			// 		nResourceInstanceId:
	// 			// 			selectedFacilitatorAction["nResourceInstanceId"],
	// 			// 	})
	// 			// 	.then((f1) => {
	// 			// 		setAuditTrail(f1);
	// 			// 	});
	// 			// let data2 = await api
	// 			// 	.getNotesHistory({
	// 			// 		nResourceInstanceId:
	// 			// 			selectedFacilitatorAction["nResourceInstanceId"],
	// 			// 	})
	// 			// 	.then((f) => {
	// 			// 		setNotesHistory(f.data);
	// 			// 	})
	// 			// 	.catch((error) => {
	// 			// 		toast(String(error.response.statusText), {
	// 			// 			autoClose: 5000,
	// 			// 			type: toast.TYPE.ERROR,
	// 			// 		});
	// 			// 	});

	// 			// setNotesDetails({
	// 			// 	sFollowupAction: "",
	// 			// 	dtFollowupOn: "",
	// 			// 	sNotes: "",
	// 			// 	bHandled: false,
	// 			// });
	// 			// setCurrentNote({}); 

	// 			//End




	// 		} else {
	// 			if (
	// 				notesDetails["dtFollowupOn"] ===
	// 					currentNote["dtFollowupOn"] &&
	// 				notesDetails["sNotes"] === currentNote["sNotes"] &&
	// 				notesDetails["sFollowupAction"] ===
	// 					currentNote["sFollowupAction"] &&
	// 				notesDetails["bHandled"] === currentNote["bHandled"]
	// 			) {
	// 				toast("No changes made", {
	// 					autoClose: 5000,
	// 					type: toast.TYPE.INFO,
	// 				});
	// 				return;
	// 			}
	// 			let data = await api
	// 				.updateNotes({
	// 					...notesDetails,
	// 					id: currentNote["id"],
	// 					nResourceInstanceId:
	// 					selectedFacilitatorAction["nResourceInstanceId"],
	// 				})
	// 				.then((d) => {
	// 					setNotesDetails({
	// 						sFollowupAction: d.data["sFollowupAction"],
	// 						dtFollowupOn: d.data["dtFollowupOn"],
	// 						sNotes: d.data["sNotes"],
	// 						bHandled: d.data["bHandled"],
	// 					});
	// 				})

	// 				.catch((error) => {
	// 					toast(String(error.response.statusText), {
	// 						autoClose: 5000,
	// 						type: toast.TYPE.ERROR,
	// 					});
	// 				});

    //               //Facilitator
	// 				// let data2 = await api
	// 				// .getAuditTrailNotesSPM({
	// 				// 	nResourceInstanceId:
	// 				// 		selectedFacilitatorAction["nResourceInstanceId"],
	// 				// })
	// 				// .then((f1) => {
	// 				// 	setAuditTrail(f1);
	// 				// });
				
	// 			//End



	// 				let payload={nResourceInstanceId:selectedFacilitatorAction["nResourceInstanceId"]};
	// 				api.getESPNotesLogByServiceId(payload).then(({ data }) => {
	// 					setAuditTrail(data);
	// 				});

	// 			let data1 = await api
	// 				.getNotesHistory({
	// 					nResourceInstanceId:
	// 					selectedFacilitatorAction["nResourceInstanceId"],
	// 				})
	// 				.then((f) => {
	// 					setNotesHistory(f.data);
	// 					f.data.map((e, i) => {
	// 						if (currentNote["id"] === e["id"]) {
	// 							setCurrentNote(e);
	// 							setNotesDetails({
	// 								...notesDetails,
	// 								currentNoteIndex: i,
	// 							});
	// 						}
	// 					});
	// 				})
	// 				.catch((error) => {
	// 					toast(String(error.response.statusText), {
	// 						autoClose: 5000,
	// 						type: toast.TYPE.ERROR,
	// 					});
	// 				});
	// 		}
	// 		 //toggleNotesModal();
	// 		// toggleNotesModal();

	// 		toast("Note saved successfully.", {
	// 			autoClose: 5000,
	// 			type: toast.TYPE.SUCCESS,
	// 		});
	// 	} catch (error) {
	// 		toast(String(error.response.statusText), {
	// 			autoClose: 5000,
	// 			type: toast.TYPE.ERROR,
	// 		});
	// 	}
	// };











	/** notes modal */

	// const [showNotesModal, setShowNotesModal] = useState(false);

	// const toggleNotesModal = () => {
	// 	setShowNotesModal(!showNotesModal);
	// };


	const [selectednResourceInstanceIdForNotes, setselectednResourceInstanceIdForNotes] = useState(null);
	const [showNotesModal, setShowNotesModal] = useState(false);
	const toggleNotesModal = (nResourceInstanceId) => {
		setselectednResourceInstanceIdForNotes(nResourceInstanceId);
		setShowNotesModal(!showNotesModal);
	};

	
	const onNotesChange = (name, value) => {
		const updated = {
			...selectedFacilitatorAction,
			[name]: value,
		};
		setSelectedFacilitatorAction(updated);
	};
	const onSaveSelectedFacilitatorAction = async () => {
		if (
			selectedFacilitatorAction["sNotes"] === "" ||
			selectedFacilitatorAction["sNotes"] === undefined ||
			selectedFacilitatorAction["sNotes"] === null
		) {
			toast("Notes field is mandetory", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		if (
			!(
				selectedFacilitatorAction["dtFollowupOn"] &&
				selectedFacilitatorAction["sFollowupAction"]
			)
		) {
			if (
				(selectedFacilitatorAction["sFollowupAction"] === "" ||
					selectedFacilitatorAction["sFollowupAction"] === null ||
					selectedFacilitatorAction["sFollowupAction"] ===
					undefined) &&
				(selectedFacilitatorAction["dtFollowupOn"] === "" ||
					selectedFacilitatorAction["dtFollowupOn"] === undefined ||
					selectedFacilitatorAction["dtFollowupOn"] === null)
			) {
			} else if (
				selectedFacilitatorAction["dtFollowupOn"] === "" ||
				selectedFacilitatorAction["dtFollowupOn"] === undefined ||
				selectedFacilitatorAction["dtFollowupOn"] === null
			) {
				toast("Followup Date is missing", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			} else if (
				selectedFacilitatorAction["sFollowupAction"] === "" ||
				selectedFacilitatorAction["sFollowupAction"] === undefined ||
				selectedFacilitatorAction["sFollowupAction"] === null
			) {
				toast("Followup Action is missing", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				return;
			} else {
			}
		}

		try {
			if (true) {
				
				let data = await api
					.updateNotes({
						id: selectedFacilitatorAction.id,
						bHandled: selectedFacilitatorAction.bHandled,
						dtFollowupOn: selectedFacilitatorAction.dtFollowupOn,
						sFollowupAction:
							selectedFacilitatorAction.sFollowupAction,
						sNotes: selectedFacilitatorAction.sNotes,
						nResourceInstanceId:
							selectedFacilitatorAction["refService"]["nResourceInstanceId"],
					})
					.then(() => {
						//toggleNotesModal();
						getFacilitatorActions(tableInstance);
					});

				setSelectedFacilitatorAction(null);
			}

			toast("Note saved successfully.", {
				autoClose: 5000,
				type: toast.TYPE.SUCCESS,
			});
		} catch (error) {
			toast(String(error.response.statusText), {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
	};
	const [
		showConfirmationModalNotes,
		setShowConfirmationModalNotes,
	] = useState(false);

	const toggleConfirmationModalNotes = () => {
		setShowConfirmationModalNotes(!showConfirmationModalNotes);
	};
	const confirmChangeNotes = () => {
		
		setSelectedFacilitatorAction({});
		//setselectedFacilitatorAction({});
		//setNotesModalVisibility(!showNotesModal);
		toggleConfirmationModalNotes();
		//setCurrentNote({});
	};
	/** */




	//Search by//

	//const [searchTerm, setSearchTerm] = useState("");
	const [searchFilter, setSearchFilter] = useState(null);
	const [filterError, setFilterError] = useState(false);

	const handleSearchInputChange = ({ target }) => {
		const { value } = target;
		setSearchTerm(value);
		if (searchFilter === null) 
		{
			setFilterError(true);
		}
	};



	const handleSearchClick = () => {
		getFacilitatorActions(tableInstance);
	};


	//Status DropDown
	let SearchByOptions=[
		{
			checked: false,
			label: "Customer Name",
			value: "Customer Name",
            code: "CustomerName",
		},
        {
			checked: false,
			label: "Service Instance ID",
			id: "Service Instance ID",
            code: "ServiceInstanceID",
		},
        {
			checked: false,
			label: "Package/Program Instance ID",
			id: "Package/Program Instance ID",
            code: "PackageProgramInstanceID",
		},
        {
			checked: false,
			label: "Customer Email ID",
			id: "Customer Email ID",
            code: "CustomerEmailID",
		},
        
        {
			checked: false,
			label: "Phone Number",
			id: "Phone Number",
            code: "PhoneNumber",
		}
	];

	const [SearchByDropdownList, setSearchByDropdownList] = useState(SearchByOptions);
    const [isSearchByDropdownOpen, setisSearchByDropdownOpen] = useState(false);
    const toggleSearchByVisibility=()=>{
        setisSearchByDropdownOpen(!isSearchByDropdownOpen);
    }

	 
	const SearchDropdownRef = useRef();
	useEffect(() => {
		const interval = setInterval(() => 
		{
			if (isSearchByDropdownOpen) 
			{
			  document.addEventListener("click", close);
			} 
			else 
			{
			  document.removeEventListener("click", close);
			}

		}, 0);
		return () => {
			clearInterval(interval)
			document.removeEventListener("click", close);
		};
	});

	const close = (e) => {
		 
	    if(isSearchByDropdownOpen)
		{
			if (SearchDropdownRef.current && SearchDropdownRef.current.contains(e.target)) 
			{
				return;
			}
			toggleSearchByVisibility();
		}		
	};

	const selectSearchBySelection = (e) => {
		let temp = SearchByDropdownList;
		let tempserach = SearchByDropdownList.map((x) => {
            if (x.code == e) {
                x.checked = !x.checked;
            }
			else
			{
				x.checked = false;
			}
            return x;
        });
        setSearchByDropdownList(tempserach);
	};



	//For Status Dropdown Option
    
	let SearchStatusByOptions=[
		{
			label: "Ready For Progression",
			value: "Ready For Progression",	
			isDisabled:false
		},
        {
			label: "Payment Confirmed By Partner",
			value: "Payment Confirmed By Partner",
			isDisabled:false
		},
        {
			label: "Awaiting For Information/Documents",
			value: "Awaiting For Information/Documents",
			isDisabled:false
		},
        {
			label: "Service Delivery Start",
			value: "Service Delivery Start",
			isDisabled:false

		},
        
        {
			label: "Service Deliverables Ready",
			value: "Service Deliverables Ready",
			isDisabled:false
		},
		{
			label: "Full Payment Requested",
			value: "Full Payment Requested",
			isDisabled:false
		},
		{
			label: "Full Payment Received",
			value: "Full Payment Received",
			isDisabled:false
		},
		{
			label: "Delivered",
			value: "Delivered",
			isDisabled:false
		},
		{
			label: "Cancelled",
			value: "Cancelled",
			isDisabled:false
		}
	];

	let StatusOptions=[
		"Ready For Progression",
		"Payment Confirmed By Partner",
		"Awaiting For Information/Documents",
		"Service Delivery Start",
		"Service Deliverables Ready",
		"Full Payment Requested",
		"Full Payment Received",
		"Delivered",
		"Cancelled", 
	];


	const [SearchsByDropdownLists, setSearchsByDropdownLists] = useState(SearchStatusByOptions);
    const [isSearchByStatusDropdownOpen, setisSearchByStatusDropdownOpen] = useState(false);
    const togglesSearchsByVisibilitys=()=>{
        setisSearchByStatusDropdownOpen(!isSearchByStatusDropdownOpen);
    }
	
	 
	const SearchsDropdownRefs = useRef();
	useEffect(() => {
		const interval = setInterval(() => 
		{
			if (isSearchByDropdownOpen) 
			{
			  document.addEventListener("click", closes);
			} 
			else 
			{
			  document.removeEventListener("click", closes);
			}

		}, 0);
		return () => {
			clearInterval(interval)
			document.removeEventListener("click", closes);
		};
	});

	const closes = (e) => {
		 
	    if(isSearchByStatusDropdownOpen)
		{
			if (SearchsDropdownRefs.current && SearchsDropdownRefs.current.contains(e.target)) 
			{
				return;
			}
			togglesSearchsByVisibilitys();
		}		
	};

	const selectSearchStatusBySelection = (e) => {
		let temp = SearchsByDropdownLists;
		let tempserach = SearchsByDropdownLists.map((x) => {
            if (x.code == e) {
                x.checked = !x.checked;
            }
			else
			{
				x.checked = false;
			}
            return x;
        });
        setSearchsByDropdownLists(tempserach);
	};


	 

	 


	//Status Modal New//

	const[selectedServiceRequestForStatusProgression,setselectedServiceRequestForStatusProgression]=useState(null);
	const [showServiceStatusModal, setshowServiceStatusModal] = useState(false);
	let sCurrentOption=
			{
				 
				label: "Cancelled",
				value: "Cancelled",		
			}		
	const[selectedOptions, setSelectedOptions]=useState(sCurrentOption);
	const toggleServiceStatusModal = () => {
		setshowServiceStatusModal(!showServiceStatusModal);
	};

	const onservicestatusclick = (original) => {
		updateStatusArray(original.refService.nResourceInstanceId);
		toggleServiceStatusModal();
		setselectedServiceRequestForStatusProgression(original);
		setSelectedOptions({
				 
			label: original.refService.refCurrentState.sServiceState,
			value: original.refService.refCurrentState.sServiceState,		
		}	);
		 
	};
	 


	// const onTabChanged = async (selectedTab) => {
    //     setCurrentActiveTab(selectedTab);
	// };


	const [currentActiveTab, setCurrentActiveTab] = useState("Service Requests");

	//status



	const [
		showCancellationReasonModal,
		setShowCancellationReasonModal,
	] = useState(false);
	const toggleCancellationReasonModal = () => {
		setShowCancellationReasonModal(!showCancellationReasonModal);
	};
	const [
		cancellationReasonDropdownOptions,
		setCancellationReasonDropdownOptions,
	] = useState();
	const [
		selectedCancellationReason,
		setSelectedCancellationReason,
	] = useState();

	const [
		enableOtherDescriptionTextbox,
		setEnableOtherDescriptionTextbox,
	] = useState(false);

	const [
		cancellationReasonOtherDescription,
		setCancellationReasonOtherDescription,
	] = useState();
	const [enableCancelButtonFlag, setEnableCancelButtonFlag] = useState(
		"disable"
	);
	useEffect(() => {
		enableCancelButton();
	}, [selectedCancellationReason, cancellationReasonOtherDescription]);

	const enableCancelButton = () => {
		if (selectedCancellationReason) {
			if (selectedCancellationReason.value === "Other") {
				if (
					cancellationReasonOtherDescription &&
					cancellationReasonOtherDescription.length > 0
				) {
					setEnableCancelButtonFlag("");
				} else setEnableCancelButtonFlag("disable");
			} else setEnableCancelButtonFlag("");
		} else setEnableCancelButtonFlag("disable");
	};

	
    const [serviceRequests, setServiceRequests] = useState([]);

	const toggleAllForServiceStatusFilter = () => 
	{
		let temp =[];
		
		if (selectedServiceStatusListForFilter.length != serviceStatusNameListForFilter.length && selectedServiceStatusListForFilter.length!=(serviceStatusNameListForFilter.length+1)) 
		{
			if(selectedServiceStatusListForFilter.includes({label: "All", value: "*"}))
			{
				temp = selectedServiceStatusListForFilter;
			}
			else{
				temp =[{label: "All", value: "*"}];
			}

			let tempSR = serviceStatusNameListForFilter.map((e) => 
			{
				if (!temp.includes(e)) 
				{
					temp = temp.concat(e);
				}
				return e;
			});
			setSelectedServiceStatusListForFilter(temp);
			setServiceStatusNameListForFilter(tempSR);
			//getExternalPartnerServices(tableInstance);
		} 
		else
		{
			setSelectedServiceStatusListForFilter([]);
			//getExternalPartnerServices(tableInstance);
		}
	};

	const toggleSelectionForServiceStatusFilter = (e) => {
		setSelectedServiceStatusListForFilter(e);
	};

	const [selectedServiceStatusListForFilter, setSelectedServiceStatusListForFilter] = useState([]);
	const [serviceStatusNameListForFilter, setServiceStatusNameListForFilter] = useState(
        [
            {
                label: "Ready for Progression",
                id: "Ready for Progression",
                value: "Ready for Progression",
            },
            {
                label: "Payment Confirmed By Partner",
                id: "Payment Confirmed By Partner",
                value: "Payment Confirmed By Partner",
            },
            {
                label: "Awaiting For Information/Documents",
                id: "Awaiting For Information/Documents",
                value: "Awaiting For Information/Documents",
            },	
            {
                label: "Service Delivery Start",
                id: "Service Delivery Start",
                value: "Service Delivery Start",
            },
            {
                label: "Service Deliverables Ready",
                id: "Service Deliverables Ready",
                value: "Service Deliverables Ready",
            },
            {
                label: "Full Payment Requested",
                id: "Full Payment Requested",
                value: "Full Payment Requested",
            },
            {
                label: "Full Payment Received",
                id: "Full Payment Received",
                value: "Full Payment Received",
            },
            {
                label: "Delivered",
                id: "Delivered",
                value: "Delivered",
            },
            {
                label: "Cancelled",
                id: "Cancelled",
                value: "Cancelled",
            },
        ]
    );


	const [stateAuditLog, setStateAuditLog] = useState();
	useEffect(() => {
		if (selectedOptions) {
			api.getStateAuditLogSPM(
				selectedOptions["nResourceInstanceId"]
			).then((d) => {
				setStateAuditLog(d.data);
			});
		}
	}, [selectedOptions]);

	const updateStatusArray = async (instance_id) => {
		try {
			const { data } = await api.searchServiceById(instance_id);
			let temp = createStatusArray(data);
			setSelectedFacilitatorAction(temp);
		} catch (err) {
			console.log("Error in updating Status Array", err);
		}
	};


	const calculateEnableOtherDescriptionTextbox = () => {
		if (
			selectedCancellationReason &&
			selectedCancellationReason.value === "Other"
		)
			setEnableOtherDescriptionTextbox(true);
		else setEnableOtherDescriptionTextbox(false);
	};
	useEffect(() => {
		calculateEnableOtherDescriptionTextbox();
	}, [selectedCancellationReason]);
	useEffect(() => {
		setSelectedCancellationReason();
		setCancellationReasonOtherDescription();
		if (selectedServiceRequestForStatusProgression && cancellationReasonDropdownOptions) {
			let temp = cancellationReasonDropdownOptions.map((e) => {
				if (e.value === selectedServiceRequestForStatusProgression.refService.sServiceCancellationReason) {
					setSelectedCancellationReason(e);
					if (e.value === "Other") {
						setCancellationReasonOtherDescription(
							selectedServiceRequestForStatusProgression.refService.sServiceCancellationReasonOtherDescription
						);
					}
				}
			});
		}

		// setSelectedCancellationReason();
	}, [selectedServiceRequestForStatusProgression, selectedOptions]);

	useEffect(() => {
		const { temp } = api.getCancellationReasons().then(({ data }) => {
			let temp1 = data.map((e) => {
				return { value: e.sReason, label: e.sReason };
			});
			setCancellationReasonDropdownOptions(temp1);
		});
	}, []);




	const createStatusArray = (d) => {
		let tempStatusArray = [];
		if (StatusOptions.indexOf(d["refCurrentState"]["sServiceState"]) >= 0)
		{
			for (let i = 0; i < 9; i++)
			{
				if (d["refCurrentState"]["sServiceState"] === "Cancelled")
				{
					//tempStatusArray.push("disable");
					SearchStatusByOptions[i].isDisabled=true
				}
				else
				{
					if (i <=StatusOptions.indexOf(d["refCurrentState"]["sServiceState"]))
					{
						//tempStatusArray.push("status-reached");
						SearchStatusByOptions[i].isDisabled=true
					}
					else if (i ==StatusOptions.indexOf(d["refCurrentState"]["sServiceState"]) +1)
					{
						//tempStatusArray.push("");
						SearchStatusByOptions[i].isDisabled=false
					}
					else
					{
						//tempStatusArray.push("disable");
						SearchStatusByOptions[i].isDisabled=true
					}
				}
			}
			if (d["sPaymentMode"] === "1_Step_Payment")
			{	
				SearchStatusByOptions[5].isDisabled=true
				SearchStatusByOptions[6].isDisabled=true
				//tempStatusArray[5] = "disable";
				//tempStatusArray[6] = "disable";
				if (d["refCurrentState"]["sServiceState"] ==="Service Deliverables ready")
					//tempStatusArray[7] = "";
					SearchStatusByOptions[7].isDisabled=false
			}

			if (d["sPaymentMode"] === "No_Payment")
			{
				SearchStatusByOptions[5].isDisabled=true
				SearchStatusByOptions[6].isDisabled=true
				// tempStatusArray[5] = "disable";
				// tempStatusArray[6] = "disable";
				if (d["refCurrentState"]["sServiceState"] ==="Service Deliverables ready")
					//tempStatusArray[7] = "";
					SearchStatusByOptions[7].isDisabled=false
			}

			SearchStatusByOptions[8].isDisabled=false
			//tempStatusArray[8] = "";
			if (d["refCurrentState"]["sServiceState"] === "Delivered")
			{
				//tempStatusArray[8] = "disable";
				SearchStatusByOptions[8].isDisabled=true
			}

			if (d["refCurrentState"]["sServiceState"] === "Cancelled")
			{
				//tempStatusArray[8] = "status-reached";
				SearchStatusByOptions[8].isDisabled=true
			}

			if(d["sPaymentMode"] === "SP_paid_service")
			{
				if(d["refCurrentState"]["sServiceState"]==="Ready For Progression")
				{
					//tempStatusArray[1]="";
					SearchStatusByOptions[1].isDisabled=false
				}
				else
				{
					//tempStatusArray[1]="status-reached";
					SearchStatusByOptions[1].isDisabled=true
				}
			}
			else
			{
				SearchStatusByOptions[1].isDisabled=true
				//tempStatusArray[1]="disable";
				if(d["refCurrentState"]["sServiceState"]==="Ready For Progression")
				{
					//tempStatusArray[2]="";
					SearchStatusByOptions[2].isDisabled=false
				}
			}

			if (d["refCurrentState"]["sServiceState"] === "Cancelled")
			{
				// tempStatusArray[0] ="disable";
				// tempStatusArray[1] ="disable";
				// tempStatusArray[2] ="disable";
				// tempStatusArray[3] ="disable";
				// tempStatusArray[4] ="disable";
				// tempStatusArray[5] ="disable";
				// tempStatusArray[6] ="disable";
				// tempStatusArray[7] ="disable";
				// tempStatusArray[8] = "status-reached";
				SearchStatusByOptions[0].isDisabled=true
				SearchStatusByOptions[1].isDisabled=true
				SearchStatusByOptions[2].isDisabled=true
				SearchStatusByOptions[3].isDisabled=true
				SearchStatusByOptions[4].isDisabled=true
				SearchStatusByOptions[5].isDisabled=true
				SearchStatusByOptions[6].isDisabled=true
				SearchStatusByOptions[7].isDisabled=true
				SearchStatusByOptions[8].isDisabled=true
			}

			if(d["nPackageInstanceId"])
			{
				// tempStatusArray[1] ="disable";
				// tempStatusArray[5] ="disable";
				// tempStatusArray[6] ="disable";
				SearchStatusByOptions[1].isDisabled=true
				SearchStatusByOptions[5].isDisabled=true
				SearchStatusByOptions[6].isDisabled=true

				if(d["refCurrentState"]["sServiceState"]==="Ready For Progression"||
				d["refCurrentState"]["sServiceState"]==="Payment Confirmed By Partner")
				{
					//tempStatusArray[2]="";
					SearchStatusByOptions[2].isDisabled=false
				}

				if (d["refCurrentState"]["sServiceState"] ==="Service Deliverables ready")
				{
					//tempStatusArray[7] = "";
					SearchStatusByOptions[7].isDisabled=false
				}
			}

			if (d["bCouponApplied"]&&(d["fAmountSecond"]<=d["fDiscountAmount"]))
			{
				SearchStatusByOptions[5].isDisabled=true
				SearchStatusByOptions[6].isDisabled=true
				// tempStatusArray[5] = "disable";
				// tempStatusArray[6] = "disable";
				if (d["refCurrentState"]["sServiceState"] ==="Service Deliverables ready")
				{
					//tempStatusArray[7] = "";
					SearchStatusByOptions[7].isDisabled=false
				}
			}
		}
		d["statusArray"] = tempStatusArray;
		setSearchsByDropdownLists(SearchStatusByOptions)

		return d;
	};


    const [isLoadingStateChange, setIsLoadingStateChange] = useState(false);
	const chanegState = () => {
		let data = {
			nResourceInstanceId: selectedServiceRequestForStatusProgression.refService.nResourceInstanceId,
		};

		let user = getUser();
		setIsLoadingStateChange(true);
		try {
			switch (selectedOptions.value) {
				case "Service Delivery Start":
					if (!selectedServiceRequestForStatusProgression.refService.refServicePartner) {
						setIsLoadingStateChange(false);
						toast("Service Partner not assigned.", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}
					if (
						user.email !==
						selectedServiceRequestForStatusProgression.refService.refServicePartner.email
					) {
						setIsLoadingStateChange(false);
						toast("You are not the assigned service partner.", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}
					if (
						user.access_rights["SERVICE"] &&
						user.access_rights["SERVICE"].includes["DELIVER"] ==
							false
					) {
						setIsLoadingStateChange(false);
						toast("You are not a service partner.", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}

					api.setServiceDeliveryStarted(data)
						.then((d) => {
							getFacilitatorActions(tableInstance);
							toggleServiceStatusModal(false);
							toast("Service updated successfully.", {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
							updateStatusArray(
								selectedServiceRequestForStatusProgression.refService.nResourceInstanceId
							);
							setIsLoadingStateChange(false);
						})
						.catch((error) => {
							toast(String(error.response.data.message), {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							setIsLoadingStateChange(false);
						});

					break;
				case "Payment Confirmed By Partner":
				api.setPaymentConfirmedbyPartner(data)
					.then((response) => {
						getFacilitatorActions(tableInstance);
						toggleServiceStatusModal(false);
						if (response.status == 202)
						{
							if(response.data.message)
							{
								toast(response.data.message, {
									autoClose: 5000,
									type: toast.TYPE.SUCCESS,
								});
							}
							else
							{
								toast("Service updated successfully.", {
									autoClose: 5000,
									type: toast.TYPE.SUCCESS,
								});
							}
						}
						else
						{
							if(response.data.message)
							{
								toast(response.data.message, {
									autoClose: 5000,
									type: toast.TYPE.ERROR,
								});
							}
							else
							{
								toast("Internal server error.", {
									autoClose: 5000,
									type: toast.TYPE.ERROR,
								});
							}
						}
						updateStatusArray(
							selectedServiceRequestForStatusProgression.refService.nResourceInstanceId
						);
						setIsLoadingStateChange(false);
					})
					.catch((error) => {
						toast(String(error.response.data.message), {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						setIsLoadingStateChange(false);
					});

				break;
				case "Awaiting For Information/Documents":
				api.setAwaitingForInformationDocuments(data)
					.then((response) => {
						getFacilitatorActions(tableInstance);
						toggleServiceStatusModal(false);
						if (response.status == 202)
						{
							if(response.data.message)
							{
								toast(response.data.message, {
									autoClose: 5000,
									type: toast.TYPE.SUCCESS,
								});
							}
							else
							{
								toast("Service updated successfully.", {
									autoClose: 5000,
									type: toast.TYPE.SUCCESS,
								});
							}
						}
						else
						{
							if(response.data.message)
							{
								toast(response.data.message, {
									autoClose: 5000,
									type: toast.TYPE.ERROR,
								});
							}
							else
							{
								toast("Internal server error.", {
									autoClose: 5000,
									type: toast.TYPE.ERROR,
								});
							}
						}
						updateStatusArray(
							selectedServiceRequestForStatusProgression.refService.nResourceInstanceId
						);
						setIsLoadingStateChange(false);
					})
					.catch((error) => {
						toast(String(error.response.data.message), {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						setIsLoadingStateChange(false);
					});

				break;
				case "Service Deliverables Ready":
					if (!selectedServiceRequestForStatusProgression.refService.refServicePartner) {
						toast("Service Partner not assigned", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}
					if (
						user.email !==
						selectedServiceRequestForStatusProgression.refService.refServicePartner.email
					) {
						toast("You are not the assigned service partner", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}
					if (
						user.access_rights["SERVICE"] &&
						user.access_rights["SERVICE"].includes["DELIVER"] ==
							false
					) {
						toast("You are not a service partner", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}

					api.setServiceDeliverablesReady(data)
						.then((d) => {
							getFacilitatorActions(tableInstance);
							toggleServiceStatusModal(false);

							updateStatusArray(
								selectedServiceRequestForStatusProgression.refService.nResourceInstanceId
							);
							toast("Service updated successfully.", {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
							setIsLoadingStateChange(false);

							// let temp = createStatusArray(d.data);
							// console.log("selected service changed to", temp);
							// setSelectedService(temp);
							// window.location.reload(false);
						})
						.catch((error) => {
							toast(String(error.response.data.message), {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							setIsLoadingStateChange(false);
						});

					break;
				case "Full Payment Requested":
					if (
						user.access_rights["SERVICE"] &&
						user.access_rights["SERVICE"].includes["MANAGE"] ==
							false
					) {
						toast("You are not a facilitator", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}
					if (
						user.email !==
						selectedServiceRequestForStatusProgression.refService.refFacilitator.email
					) {
						toast("You are not the assigned facilitator", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}

					api.setFullPaymentRequested(data)
						.then((d) => {
							getFacilitatorActions(tableInstance);
							toggleServiceStatusModal(false);
							toast("Service updated successfully.", {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
							updateStatusArray(
								selectedServiceRequestForStatusProgression.refService.nResourceInstanceId
							);
							setIsLoadingStateChange(false);

							// setSelectedService(d.data);
							// document.location.reload(true);
						})
						.catch((error) => {
							toast(String(error.response.data.message), {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							setIsLoadingStateChange(false);
						});

					break;
				case "Full Payment Received":
					if (
						user.access_rights["SERVICE"] &&
						user.access_rights["SERVICE"].includes["MANAGE"] ==
							false
					) {
						toast("You are not a facilitator", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}
					if (
						user.email !==
						selectedServiceRequestForStatusProgression.refService.refFacilitator.email
					) {
						toast("You are not the assigned facilitator", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}

					api.setFullPaymentComplete(data)
						.then((d) => {
							getFacilitatorActions(tableInstance);
							toggleServiceStatusModal(false);
							toast("Service updated successfully.", {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
							updateStatusArray(
								selectedServiceRequestForStatusProgression.refService.nResourceInstanceId
							);
							setIsLoadingStateChange(false);

							// setSelectedService(d.data);
							// document.location.reload(true);
						})
						.catch((error) => {
							toast(String(error.response.data.message), {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							setIsLoadingStateChange(false);
						});

					break;
				case "Delivered":
					if (
						user.access_rights["SERVICE"] &&
						user.access_rights["SERVICE"].includes["MANAGE"] ==
							false
					) {
						toast("You are not a facilitator", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}
					if (
						user.email !==
						selectedServiceRequestForStatusProgression.refService.refFacilitator.email
					) {
						toast("You are not the assigned facilitator", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}

					api.setServiceDelivered(data)
						.then((d) => {
							getFacilitatorActions(tableInstance);
							toggleServiceStatusModal(false);
							toast("Service updated successfully.", {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
							updateStatusArray(
								selectedServiceRequestForStatusProgression.refService.nResourceInstanceId
							);
							setIsLoadingStateChange(false);

							// setSelectedService(d.data);
							// window.location.reload(true);
						})
						.catch((error) => {
							toast(String(error.response.data.message), {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							setIsLoadingStateChange(false);
						});

					break;
				case "Cancelled":
					if (
						user.access_rights["SERVICE"] &&
						user.access_rights["SERVICE"].includes["MANAGE"] ==
							false
					) {
						toast("You are not a facilitator", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}
					if (
						user.email !==
						selectedServiceRequestForStatusProgression.refService.refFacilitator.email
					) {
						toast("You are not the assigned facilitator", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}
					if (
						selectedServiceRequestForStatusProgression.refService.refCurrentState.sServiceState === "Delivered"
					) {
						toast("A delivered service can not be cancelled", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;
					}

					let cancellation_Reason, OtherDescription;
					if (selectedCancellationReason) {
						cancellation_Reason = selectedCancellationReason.value;
						if (cancellation_Reason !== "Other")
							OtherDescription = null;
						else
							OtherDescription = cancellationReasonOtherDescription;
					}

					if(!selectedCancellationReason){
						toast("Please select cancellation reason", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;

					}
					if(selectedCancellationReason.value==="Other"&&(!cancellationReasonOtherDescription)){
						toast("Please enter cancellation reason other description", {
							autoClose: 5000,
							type: toast.TYPE.ERROR,
						});
						return;

					}

					api.setServiceCancelled({
						...data,
						cancellationReason: cancellation_Reason,
						cancellationReasonOtherDescription: OtherDescription,
					})
						.then((d) => {
							getFacilitatorActions(tableInstance);
							toggleServiceStatusModal(false);
							toast("Service updated successfully.", {
								autoClose: 5000,
								type: toast.TYPE.SUCCESS,
							});
							updateStatusArray(
								selectedServiceRequestForStatusProgression.refService.nResourceInstanceId
							);
							toggleCancellationReasonModal();
							setIsLoadingStateChange(false);

							// setSelectedService(d.data);
							// window.location.reload(false);
						})
						.catch((error) => {
							toast(String(error.response.data.message), {
								autoClose: 5000,
								type: toast.TYPE.ERROR,
							});
							setIsLoadingStateChange(false);
						});

					break;
				default:
					break;
			}

			// console.log("data === >", data);
			// toast("Status changed successfully.", {
			//   autoClose: 5000,
			//   type: toast.TYPE.SUCCESS,
			// });
		} catch (error) {
			toast(String(error.response.data.message), {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
		}
		
	};
 
	 
		
	//End status


	//const [showFeedbackModal,setshowFeedbackModalVisibility]=useState(false);

	 

	const [refExternalServicePartnerEmailIDForFeedback, setrefExternalServicePartnerEmailIDForFeedback] = useState();
	const [sServiceNameForFeedback, setsServiceNameForFeedback] = useState();
	const [nResourceInstanceIdForFeedback, setnResourceInstanceIdForFeedback] = useState();
	const [showServiceFeedbackModal, onSetShowServiceFeedbackModal] = useState(false);
	const toggleServiceFeedbackModal = () => {
		onSetShowServiceFeedbackModal(!showServiceFeedbackModal);
	};


	const handleOnShowFeedback = (e, origin) => {
		setnResourceInstanceIdForFeedback(origin["refService"]["nResourceInstanceId"]);
		setsServiceNameForFeedback(getServiceName(origin));		
		if(origin.refService.refExternalServicePartner&&origin.refService.refExternalServicePartner.sServicePartnerEmail)
		{
			setrefExternalServicePartnerEmailIDForFeedback(origin.refService.refExternalServicePartner.sServicePartnerEmail)
		}			
		toggleServiceFeedbackModal();
	};


	const [showFeedbackModal,setshowFeedbackModalVisibility]=useState(false);
	const toggleShowFeedbackModal=()=>{
		setshowFeedbackModalVisibility(!showFeedbackModal);
	}

	///** */

	const getServiceName = (original) => {
		if (!original) return;
		const found = find(getServiceTypesMaster(), {
			sServiceCode: original.sServiceCode,
		});
		if (found) {
			return found.refService.sServiceName;
		}
		return "";
	};

	//
	
	useEffect(() => {
		getFacilitatorActions(tableInstance);
	}, []);

    return(
		<>
			<div className={`row ${isLoading && "set-opacity"}`}>
				{isLoading && <Spinner className="center-screen" />}
				     
						<FacilitatorActionsFilterSection
						dateRangeOption={dateRangeOption}
						onDateRangeChange={onDateRangeChange}
						onDateFilterChange={onDateFilterChange}
						dateFilter={dateFilter}
						fromDate={fromDate}
						toDate={toDate}
						onSearchClicked={onSearchClicked}

						SearchByDropdownList={SearchByDropdownList}
						isSearchByDropdownOpen={isSearchByDropdownOpen}
						toggleSearchByVisibility={toggleSearchByVisibility}
						SearchDropdownRef={SearchDropdownRef}
						selectSearchBySelection={selectSearchBySelection}


						searchTerm={searchTerm}
						onSearchInputChange={handleSearchInputChange}
						onSearchClickedd={handleSearchClick}



						showIncompleteActions={showIncompleteActions}
						toggleShowIncompleteActions={toggleShowIncompleteActions}

						//onSearchClicked={handleSearchClick}
						//onClearFilterSearch={handleClearFilterSearch}

						></FacilitatorActionsFilterSection>
			
						<FacilitatorGridTable
						user={getUser()}
						data={facilitatorActionsList}
						selectedFacilitatorAction={selectedFacilitatorAction}
						onSelectFacilitatorAction={onSelectFacilitatorAction}
						onFetchServiceRequests={getFacilitatorActions}
						//pages={pages}
						//pageSize={PAGE_SIZE}
						pages={pages}
						pageSize={pageSize}
						page={currentPage}
						pageSizeOptions={pageSizeOptions}
						selectedPageSizeOption={selectedPageSizeOption}
						onPageSizeOptionChange={(option) => {
						setSelectedPageSizeOption(option);
						}}
						stateAuditLog={stateAuditLog}

						/**Notes modal  */
						facilitatorActionView={true}
						showNotesModal={showNotesModal}
						toggleNotesModal={toggleNotesModal}
						onNotesChange={onNotesChange}
						onSaveSelectedFacilitatorAction={
							onSaveSelectedFacilitatorAction
						}
						showConfirmationModalNotes={showConfirmationModalNotes}
						toggleConfirmationModalNotes={toggleConfirmationModalNotes}
						confirmChangeNotes={confirmChangeNotes}
						selectednResourceInstanceIdForNotes={selectednResourceInstanceIdForNotes}


						       //auditTrail={auditTrail}
								//changeSelectedNotesDetails={changeSelectedNotesDetails}
								//notesHistory={notesHistory}



                        // Notes Modal New
								// facilitatorActionView={true}
								// auditTrail={auditTrail}
								// changeSelectedNotesDetails={changeSelectedNotesDetails}
								// notesHistory={notesHistory}
								// notesDetails={notesDetails}
								// showNotesModal={showNotesModal}
								// toggleNotesModal={toggleNotesModal}
								// onNotesChange={onNotesChange}
								// onSaveNotesDetails={onSaveNotesDetails}
								// //onSaveSelectedFacilitatorAction={onSaveSelectedFacilitatorAction}
								// showConfirmationModalNotes={showConfirmationModal}
								// toggleConfirmationModalNotes={toggleConfirmationModalNotes}
								// confirmChangeNotes={confirmChangeNotes}

								// //Need to talk to SP

								// needToTalkToSPOptions={needToTalkToSPOptions}
								// selectedNeedToTalkToSPOption={selectedNeedToTalkToSPOption}
								// setSelectedNeedToTalkToSPOption={setSelectedNeedToTalkToSPOption}
								// onUpdateNeedToTalkToSPFlag={onUpdateNeedToTalkToSPFlag}
                                //End 






						//feedback
						 
						toggleShowFeedbackModal={handleOnShowFeedback}
						//toggleViewAllNotesModal={handleAllNotes}

						 



						//StatusModalNew
						showServiceStatusModal={showServiceStatusModal}
						toggleServiceStatusModal={toggleServiceStatusModal}
						//onservicestatusclick={onservicestatusclick}
						SearchsByDropdownLists={SearchsByDropdownLists}
						isSearchByStatusDropdownOpen={isSearchByStatusDropdownOpen}
						togglesSearchsByVisibilitys={togglesSearchsByVisibilitys}
						SearchsDropdownRefs={SearchsDropdownRefs}
						selectSearchStatusBySelection={selectSearchStatusBySelection}
						selectedOptions={selectedOptions}
						onStatusOptionChange={onStatusOptionChange}
						onservicestatusclick ={onservicestatusclick}

						selectedServiceRequestForStatusProgression={selectedServiceRequestForStatusProgression}
						 
						

						changeState={chanegState}

						 



						enableCancelButtonFlag={enableCancelButtonFlag}
						showCancellationReasonModal={showCancellationReasonModal}
						toggleCancellationReasonModal={toggleCancellationReasonModal}
						cancellationReasonDropdownOptions={
						cancellationReasonDropdownOptions
						}
						setSelectedCancellationReason={setSelectedCancellationReason}
						selectedCancellationReason={selectedCancellationReason}
						enableOtherDescriptionTextbox={enableOtherDescriptionTextbox}
						cancellationReasonOtherDescription={
						cancellationReasonOtherDescription
						}
						onChangeCancellationReasonOtherDescription={(value) =>
						setCancellationReasonOtherDescription(value)
						}
						// showSendNeftDetailsModal={showSendNeftDetailsModal}
						// setShowSendNeftDetailsModal={setShowSendNeftDetailsModal}
						



						//All notes

						// showViewAllNotesModal={showViewAllNotesModal}
						// toggleViewAllNotesModal={toggleViewAllNotesModal}
						// sEmailAddress={null}
						// nResourceInstanceId={nResourceInstanceIdForAllNotes}
						// sServiceNameForAllNotes={sServiceNameForAllNotes}
						// sEmailAddressForAllNotes={sEmailAddressForAllNotes}




						
						//status
						toggleAllForServiceStatusFilter={toggleAllForServiceStatusFilter}
						toggleSelectionForServiceStatusFilter={toggleSelectionForServiceStatusFilter}
						selectedServiceStatusListForFilter={selectedServiceStatusListForFilter}
						serviceStatusNameListForFilter={serviceStatusNameListForFilter}

				        />

						{
								showServiceFeedbackModal&&
								(
									<UserFeedbackModal
										isOpen={showServiceFeedbackModal}
										toggleModal={toggleServiceFeedbackModal}
										sEmailAddress={null}
										nResourceInstanceId={nResourceInstanceIdForFeedback}
										sServiceNameForFeedback={sServiceNameForFeedback}
										refExternalServicePartnerEmailIDForFeedback={refExternalServicePartnerEmailIDForFeedback}
									>
									</UserFeedbackModal>
								)
						}


							{/* {
									showViewAllNotesModal&&
									(
									<CentralizedNotesModal
									isOpen={showViewAllNotesModal}
									toggleModal={toggleViewAllNotesModal}
									//sEmailAddress={props.service.sEmailAddress||sEmailAddressForAllNotes}
									//sEmailAddress={null}
									nResourceInstanceId={nResourceInstanceIdForAllNotes}
									sServiceNameForAllNotes={sServiceNameForAllNotes}
									sEmailAddressForAllNotes={sEmailAddressForAllNotes}
						 
									>
									</CentralizedNotesModal>
									)
							} */}
						 
						{/* {
							<ServiceStatusModal
							isOpen={showServiceStatusModal}
							toggleModal={toggleServiceStatusModal}							
							SearchsByDropdownLists={SearchsByDropdownLists}				
							isSearchByStatusDropdownOpen={isSearchByStatusDropdownOpen}
							togglesSearchsByVisibilitys={togglesSearchsByVisibilitys}
							//SearchDropdownRef={SearchDropdownRef}
							SearchsDropdownRefs={SearchsDropdownRefs}
							//selectSearchBySelection={selectSearchBySelection}
							selectSearchStatusBySelection={selectSearchStatusBySelection}
							selectedOptions={selectedOptions}
							onStatusOptionChange={onStatusOptionChange}
							
							// toggleAll={toggleAllForServiceStatusFilter}
							// toggleSelection={toggleSelectionForServiceStatusFilter}
							// checkboxItemsList={serviceStatusNameListForFilter}
							// selectedOptions={selectedServiceStatusListForFilter}
							// placeholderButtonLabel ={"Select Status"}	
							>
							</ServiceStatusModal>
						} */}
						 
			</div>
					
		</>

	);
}